import React, { useState } from "react";
import CloseIcon from "@styles/all-images/icons/closeblack.svg";
import idwalaIcon from "@/styles/all-images/icons/idwala.svg";
import tegmulIcon from "@/styles/all-images/icons/tegmul.svg";
import fuelcapIcon from "@/styles/all-images/icons/fuelcap.svg";
import greencheck from "@/styles/all-images/icons/greencheck.svg";

interface FilterModalProps {
  onClose: () => void;
  onApply: (selectedCompanies: string[]) => void;
  isOpen: boolean;
}

const FilterModal = ({ onClose, onApply, isOpen }: FilterModalProps) => {
  const handleApply = () => {
    onApply(["Selected Company"]);
    onClose();
  };

  const [selectedCompany, setSelectedCompany] = useState(
    "Tegmul Fabrication Pty Ltd.",
  );

  const companies = [
    { name: "Idwala Energy Pty Ltd.", icon: idwalaIcon },
    { name: "Tegmul Fabrication Pty Ltd.", icon: tegmulIcon },
    { name: "FuelCap Pty Ltd.", icon: fuelcapIcon },
  ];

  return (
    <div
      className={`tw-w-[350px] tw-fixed tw-bg-black/25 tw-top-0 tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-z-50 tw-transition-all tw-ease-in-out tw-duration-1000 ${
        isOpen ? "tw-right-0" : "tw-right-[-265px]"
      }`}
    >
      <div className="tw-bg-white tw-shadow-lg tw-mx-auto tw-h-screen">
        <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-4 tw-border-b">
          <h2 className="tw-text-base tw-font-semibold">Filter</h2>
          <button onClick={onClose}>
            <img src={CloseIcon} alt="Close" className="tw-w-auto tw-h-auto" />
          </button>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-between tw-h-[95%] tw-px-4 tw-py-4">
          <div>
            <div>
              <label className="tw-text-sm tw-font-semibold tw-text-[#414651]">
                Select Company
              </label>
            </div>
            <div className="tw-space-y-2">
              {companies.map((company) => (
                <div
                  key={company.name}
                  className={`tw-flex tw-items-center tw-p-3 tw-rounded-lg tw-cursor-pointer tw-w-80  tw-my-4 tw-border tw-border-[#E9EAEB] ${
                    selectedCompany === company.name
                      ? "tw-bg-[#ECFDF3] tw-border tw-border-[#E9EAEB] tw-text-[#027A48]"
                      : "tw-bg-white hover:tw-bg-gray-100 tw-text-[#027A48]"
                  }`}
                  onClick={() => setSelectedCompany(company.name)}
                >
                  <img
                    src={company.icon}
                    className="tw-mr-3"
                    alt={`${company.name} logo`}
                  />
                  <span className="tw-flex-1 tw-ml-2 tw-text-[#232323]">
                    {company.name}
                  </span>
                  {selectedCompany === company.name && (
                    <img src={greencheck} alt="Green Check" />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="tw-p-4 tw-flex tw-items-center tw-gap-4">
            <button
              onClick={onClose}
              className="tw-px-6 tw-py-2 tw-w-full tw-border font-default-primary-color tw-border-[#146C94] tw-rounded-lg tw-text-center"
            >
              Clear
            </button>
            <button
              onClick={handleApply}
              className="tw-text-white tw-w-full tw-rounded-md tw-py-2 tw-px-6 tw-bg-[#146C94]"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
